var exports = {
  "w": "TimeoutMemberSheet.module__header___eUUwaT",
  "h": "TimeoutMemberSheet.module__description___eUUwaT",
};

module.exports = exports;
